import { BooleanStatusDisplay } from "@/common/components/Status/BooleanStatusDisplay";
import { StatusDisplayProps } from "@/common/components/Status/StatusDisplay";
import { ApiEnumName } from "@/common/services/enum";
import { UtilizationStatus } from "@/core/api/generated/v1";

import GeneralStatusEnumValueInline, {
  GeneralStatusEnumValueInlineProps,
} from "../GeneralStatusEnumValueInline";
import { UtilizationStatusIndicator } from "./UtilizationStatusIndicator";

interface Props {
  status: UtilizationStatus | undefined;
  statusProps?: Partial<StatusDisplayProps>;
  enumInlineProps?: Partial<GeneralStatusEnumValueInlineProps>;
}

export function UtilizationStatusDisplay({ status, statusProps, enumInlineProps }: Props) {
  return (
    <BooleanStatusDisplay
      value={null}
      statusProps={{
        title: (
          <GeneralStatusEnumValueInline
            statusEnumTypeName={ApiEnumName.UtilizationStatus}
            status={status}
            {...enumInlineProps}
          />
        ),
        indicator: <UtilizationStatusIndicator status={status} />,
        ...statusProps,
      }}
    />
  );
}
